<template>
  <div class="v-menu scrollbar">
    <Menu ref="menus" theme="dark" :active-name="activeName" :open-names="['0', '1', '2', ...openNames]" width="220">
      <Submenu name="0" :open-names="['/analy/computer']">
        <template slot="title">
          <Icon type="md-analytics" />监控中心
        </template>
        <MenuItem name="/analy/runtime" to="/analy/runtime">实时监控</MenuItem>
        <MenuItem name="/analy/daily" to="/analy/daily">日常监控</MenuItem>
        <MenuItem name="/analy/computer" to="/analy/computer">监控机器</MenuItem>
        <MenuItem name="/analy/usage" to="/analy/usage">使用统计</MenuItem>
      </Submenu>
      <Submenu name="1" :open-names="['/orgen/entry']">
        <template slot="title">
          <Icon type="md-analytics" />机构账户
        </template>
        <MenuItem name="/orgen/entry" to="/orgen/entry">机构账户</MenuItem>
      </Submenu>
      <Submenu name="2" :open-names="['/env/serverlist']">
        <template slot="title">
          <Icon type="ios-settings" />环境配置（上一层）
        </template>
        <MenuItem name="/env/serverlist" to="/env/serverlist">机库配置</MenuItem>
      </Submenu>
      <Submenu
        v-for="(item, index) of serverList"
        :key="index"
        :name="'m' + item.mid"
        :open-names="[`/pool/poollist/${item.mid}`, `/pool/taglist/${item.mid}`]"
      >
        <template slot="title">
          <Icon type="ios-apps" />
          {{ item.name }}
        </template>
        <MenuItem :name="`/pool/poollist/${item.mid}`" :to="`/pool/poollist/${item.mid}`" :replace="true"
          >游机机房</MenuItem
        >
        <MenuItem :name="`/pool/taglist/${item.mid}`" :to="`/pool/taglist/${item.mid}`" :replace="true"
          >队列标签</MenuItem
        >
        <MenuItem :name="`/pool/pooledit/${item.mid}`" :to="`/pool/pooledit/${item.mid}`" :replace="true"
          >机房上下架</MenuItem
        >
      </Submenu>
    </Menu>
  </div>
</template>
<script>
import { Menu, Submenu, MenuItem, Icon } from 'view-design';
export default {
  components: {
    Menu,
    Submenu,
    MenuItem,
    Icon,
  },
  data() {
    return {
      activeName: '/env/serverlist',
      serverList: [],
      openNames: [],
    };
  },
  watch: {
    $route: function() {
      this.activeName = this.$route.path;
    },
  },
  created() {
    this.activeName = this.$route.path;
    this.getMenu();
  },
  methods: {
    //获取menu
    async getMenu() {
      const res = await this.$api.baseEnv.getServerList();
      if (res.success && res.data.code == 0) {
        let data = res.data.data;
        if (!data) {
          return;
        }
        this.serverList = data.servers || [];
        this.openNames = this.serverList.map(item => {
          return 'm' + item.mid;
        });
        this.$nextTick(() => {
          //获取数据后更新菜单状态
          this.$refs.menus.updateOpened();
          this.$refs.menus.updateActiveName();
        });
      } else {
        this.$Message.error(res.data.message);
      }
    },
  },
};
</script>
